import * as me from './rest/me';
import * as register from './rest/register';
import { login } from './rest/login';
import * as sendInvitation from './rest/send_invitation';
import * as sendAgreement from './rest/send_agreement';
import * as staticResources from './rest/staticResources';
import * as immigrationProfessional from './rest/immigration_professional';
import * as licenses from './rest/licenses';
import * as resource from './rest/resource';
import * as myAccount from './rest/my_account';
import * as tableInput from './rest/table_input';
import * as opportunities from './rest/opportunities';
import * as assessment from './rest/assessment';
import * as assessmentTopPicks from './rest/assessment_top_picks';
import * as serviceProvider from './rest/service_provider';
import * as serviceProviderList from './rest/service_provider_list';
import * as serviceProviderInfo from './rest/service_provider_info';
import * as listImmigrationProfessionals from './rest/list_immigration_professionals';
import * as chat from './rest/chat';
import * as chatNew from './rest/chat_new';
import * as notification from './rest/notification';
import * as myClients from './rest/my_clients';
import * as calendar from './rest/calendar';
import * as applications from './rest/applications';
import * as application from './rest/application';
import * as documentResource from './rest/document_resource';
import * as documentProperties from './rest/document_properties';
import * as forgotPassword from './rest/forgot_password';
import * as resetPassword from './rest/reset_password';
import * as agreement from './rest/agreement';
import * as assessmentAgreement from './rest/assessment_agreement';
import * as services from './rest/services';
import * as documentTemplates from './rest/document_templates';
import * as payments from './rest/payments';
import * as residenceStatus from './rest/residence_status';
import * as checkEmail from './rest/check_email';
import * as consultation from './rest/consultation';
import * as externalClient from './rest/external_client';
import * as externalClients from './rest/external_clients';
import * as setClientRole from './rest/set_client_role';
import * as documentComments from './rest/document_comments';
import * as paymentReceipt from './rest/payment_receipt';
import * as clientList from './rest/client_list';
import * as events from './rest/events';
import * as payouts from './rest/payouts';
import * as userCount from './rest/user_count';
import * as eventLogs from './rest/event_log';
import * as authentication from './rest/authenticate';
import * as setPassword from './rest/set_password_with_auth_code';
import * as notes from './rest/notes';
import * as servicePaid from './rest/service_paid';
import * as clients from './rest/clients';
import * as setApplicationPaymentStatus from './rest/set_application_payment_status';
import * as clientPaymentStatus from './rest/client_payment_status';
import * as tickets from './rest/tickets';
import * as allCandidateInfo from './rest/all_candidate_info';
import * as candidateProfile from './rest/candidate_profile';
import * as agents from './rest/agents';
import * as expertiseList from './rest/expertise_list';
import * as clientHistory from './rest/clientHistory';
import * as fileHistory from './rest/fileHistory';
import * as assessment_payment from './rest/assessment_payment';
import * as companies from './rest/companies';
import * as clientServiceProviders from './rest/client_service_providers';
import * as job_recommendation from './rest/job_recommendation';
import * as report from './rest/report';
import * as governmentForms from './rest/government_forms';
import * as programList from './rest/program_list';
import * as allDocuments from './rest/all_documents';
import * as documentChecklist from './rest/document_checklist';
import * as calendar_events from './rest/calendar_events';
import * as assessment_options from './rest/assessment_options';
import * as activityEvents from './rest/activityEvents';
import * as admin from './rest/admin';
import * as single_assessment from './rest/single_assessment';
import * as sop from './rest/sop';
import * as permissions from './rest/permissions';
import * as invoices from './rest/invoices';
import * as completedForms from './rest/completed-forms';
import * as chat_with_ai from './rest/chat_with_ai';
import * as fieldsOfStudy_recommendation from './rest/recommended_fields_of_study';
import * as applicationRetainers from './rest/application_retainers';
import * as retainerTemplates from './rest/retainer_templates';
import * as signatures from './rest/signatures';
import * as signRetainer from './rest/signRetainer.api';
import * as analytics from './rest/analytics';
import * as myaliroBilling from './rest/myaliro_billing';
import * as engagementScore from './rest/engagement_score';
import * as userDocuments from './rest/user_documents';
import * as referenceData from './rest/referenceData.api';
import * as visaApplication from './rest/visaApplication.api';
import * as spouseProfile from './rest/spouseProfile';
import * as serviceProviderBilling from './rest/serviceProviderBilling';
import * as programQuestions from './rest/programQuestions';
export * from './models';
export * from './models/payload';
export * from './models/response';

export { axiosDefault } from './axiosDefault';

export * from 'axios';

const api = {
    register,
    me,
    events,
    login,
    authentication,
    setPassword,
    staticResources,
    checkEmail,
    forgotPassword,
    resetPassword,
    resource,
    sendInvitation,
    sendAgreement,
    residenceStatus,
    immigrationProfessional,
    licenses,
    myAccount,
    tableInput,
    opportunities,
    assessment,
    assessmentTopPicks,
    serviceProvider,
    serviceProviderList,
    serviceProviderInfo,
    listImmigrationProfessionals,
    chat,
    chatNew,
    notification,
    myClients,
    clients,
    calendar,
    applications,
    application,
    documentResource,
    documentProperties,
    agreement,
    assessmentAgreement,
    services,
    documentTemplates,
    payments,
    consultation,
    externalClient,
    externalClients,
    setClientRole,
    documentComments,
    paymentReceipt,
    clientList,
    payouts,
    userCount,
    eventLogs,
    notes,
    servicePaid,
    setApplicationPaymentStatus,
    clientPaymentStatus,
    tickets,
    allCandidateInfo,
    candidateProfile,
    agents,
    expertiseList,
    clientHistory,
    fileHistory,
    assessment_payment,
    companies,
    clientServiceProviders,
    job_recommendation,
    report,
    governmentForms,
    calendar_events,
    programList,
    allDocuments,
    documentChecklist,
    assessment_options,
    activityEvents,
    admin,
    single_assessment,
    sop,
    permissions,
    invoices,
    completedForms,
    chat_with_ai,
    fieldsOfStudy_recommendation,
    applicationRetainers,
    retainerTemplates,
    signatures,
    analytics,
    myaliroBilling,
    engagementScore,
    userDocuments,
    referenceData,
    visaApplication,
    spouseProfile,
    signRetainer,
    serviceProviderBilling,
    programQuestions,
};

export default api;
